export default __webpack_public_path__ + "static/13-28a03374281704dfed0cc6d3344166de.jpg";